/*
* @module : Result
* @file : Result.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of Result
*
* Created on : 12-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 25-Oct-2019
*/

import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import $ from 'jquery';
import GiftService from '../../services/GiftService/GiftService';
import Translation from '../../language/Translation';
class Result extends React.Component
{
	constructor(props)
	{
		
		super(props);
		this.translation = new Translation();
		this.state = {
			gifts:[],
			redirect: 0,
			translation:{
				'result_v1':this.translation.getText('result_v1'),
				'result_v2':this.translation.getText('result_v2'),
				'result_v3':this.translation.getText('result_v3'),
				'result_v4':this.translation.getText('result_v4'),
				'result_v5':this.translation.getText('result_v5'),
				'result_v6':this.translation.getText('result_v6'),
				'result_v7':this.translation.getText('result_v7'),
				'result_v8':this.translation.getText('result_v8'),
				'result_v9':this.translation.getText('result_v9'),
				'result_v10':this.translation.getText('result_v10'),
				'result_v11':this.translation.getText('result_v11'),
				'result_v12':this.translation.getText('result_v12'),
				'result_v13':this.translation.getText('result_v13')
			},
		};
		this.giftService = new GiftService();
		this.addGift = this.addGift.bind(this);
		this.renderRedirect = this.renderRedirect.bind(this);

	}

	addGift()
	{
		let gift_id = $("input[name='gift_id']:checked").val();
		if(gift_id==='' || typeof gift_id==='undefined')
		{
			$('.btn-primary').addClass('shake');
			setTimeout(function()
			{
				$('.btn-primary').removeClass('shake');
			},900);
		}
		else
		{
			$("#btnSubmit").attr("disabled", true);
		if(gift_id==='no_gift')
		{
			$('#btnSubmit').removeAttr("disabled");
			this.setState({redirect:1});
		}
		else if(gift_id==='no')
		{
			this.setState({redirect:3});
		}
		else
		{
			this.giftService.addGift(gift_id).then(response=>{
				$('#btnSubmit').removeAttr("disabled");
				if(response.status==='1')
				{
					this.setState({redirect:2});
				}
			});
		}
		}
	}
	renderRedirect() {
		
    if (this.state.redirect===1) {
    	return <Redirect to='/thank-you' />
    }
    else if(this.state.redirect===2)
    {
    	return <Redirect to='/user-details' />
    }
    else if(this.state.redirect===3)
    {
    	//return <Redirect to={`/topics/${this.state.gifts.topic_id}/question/`} />
    	return <Redirect to={`/topics`} />
    }
  	}
	componentDidMount()
	{
		this.giftService.getAllGift().then(response=>{
			this.setState({gifts:response});
		});
	}

	renderChallenger()
	{
		let gifts = this.state.gifts;
		//console.log(gifts.gifts);
		if(gifts.status==='1')
		{
			if(gifts.challenger_name!==null && typeof gifts.challenger_name!=='undefined' && gifts.challenger_name!=="")
			{
				this.state.translation.result_v9 = this.state.translation.result_v9.replace('%challenger_name%',''+gifts.challenger_name+'');
				this.state.translation.result_v9 = this.state.translation.result_v9.replace('%challenger_score%',''+gifts.challenger_score+'');
				return (
					<React.Fragment>
						<p>{this.state.translation.result_v9}</p>
					</React.Fragment>
				)
			}
			else
			{
				return(
					<React.Fragment>
					</React.Fragment>
				)
			}
		}
		else
			{
				return(
					<React.Fragment>
					</React.Fragment>
				)
			}
	}

	render0Text()
	{
       let gifts = this.state.gifts;  
		if(gifts.score=='0')
		{
			return(
				<React.Fragment>
				 <div className="default-heading fontSize">
		        	<h2>Sie haben leider 0 Punkte erreicht.</h2>
                 </div>
                  <div className="paragraph-area paragraph-area-small">
                  <p> Möchten Sie das Quiz wiederholen oder einen Trostpreis erhalten?</p> ​​
                  </div>
		  
               </React.Fragment>
			)
		}
		else
			{
				return(
					<React.Fragment>
					<div className="default-heading fontSize">
		        	<h2>{this.state.translation.result_v1}, <br/> {this.state.translation.result_v2} <strong>{gifts.score} {this.state.translation.result_v3}</strong> {this.state.translation.result_v4} ​​</h2>
		        </div>
		        <div className="paragraph-area paragraph-area-small">
		        {this.renderChallenger()}
		        	<p>{this.state.translation.result_v11}<br/>{this.state.translation.result_v5}<br/>{this.state.translation.result_v10}</p>
		        	<p>​{this.state.translation.result_v6} ​<strong>{this.state.translation.result_v7}</strong></p>
		        </div>
					</React.Fragment>
				)
			}
		
	}

	render0Link()
	{
       let gifts = this.state.gifts;  
		if(gifts.score=='0')
		{
			return(
				<React.Fragment>
				<br/>
				 <div className="text-center">     
                  <Link to="/topics/" className="link-live">Quiz wiederholen</Link>
                 </div>
               </React.Fragment>
			)
		}
	}

	renderGifts()
	{
		let gifts = this.state.gifts;
		//console.log(gifts.gifts);
		if(gifts.status==='1')
		{
			//let divClass = (gifts.score=='0')?'col-12 col-sm-12 col-md-12 col-lg-12 text-center':'col-12 col-sm-4 col-md-4 col-lg-4';
			//let figureClass = (gifts.score=='0')?'bach-img no-gift':'bach-img';
			let divClass = (gifts.score=='0')?'col-12 col-sm-6 col-md-6 col-lg-6':'col-12 col-sm-4 col-md-4 col-lg-4';
			let figureClass = 'bach-img';
			if(gifts.score===0)
			{
				gifts.gifts[1] = {'id':'no','name':'Quiz wiederholen','img':'https://quiz.wanitsch.ch/quiz/img/no.png'}; 
			}
			return Object.keys(gifts.gifts).map(function(key) {
				return (
					<React.Fragment key={key}>
						<div className={divClass} key={key}>
		    			<figure className={figureClass}><img src={gifts.gifts[key].img} alt={gifts.gifts[key].img}/>
		    			</figure>
		    			<div className="custom-control custom-radio">
		    					<input type="radio" id={gifts.gifts[key].id} value={gifts.gifts[key].id} name="gift_id" className="custom-control-input"/>
		    					<label className="custom-control-label" htmlFor={gifts.gifts[key].id}>{gifts.gifts[key].name}</label>
		    			</div>
		        	</div>
					</React.Fragment>	
				)
			});
		}
	}

	renderGiftData()
	{
		let gifts = this.state.gifts;
		if(gifts.status==='1')
		{
		
		return (
			<React.Fragment>
			{this.render0Text()}
				
		        <div className="buch-area">
		        	<div className="row align-content-between align-items-center">
		        		{this.renderGifts()}
		        	</div>
		        </div>
			</React.Fragment>
		);
	}
	}

	render()
	{
		let addGift = this.addGift;
		return(
			<React.Fragment>
			{this.renderRedirect()}
			<div className="content-box-area padd">
			 <div className="progress-bar large-Width"></div>
			  <div className="top-area">
			   <div className="row align-content-between align-items-center">
			    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
			     
			    </div>
			   </div>
			  </div>
              {this.renderGiftData()}
         
        <div className="buch-area">
        <div className="row align-content-between align-items-center">
        </div>
        </div>       
        <div className="text-center buttons-area">     
          <button className="btn btn-primary" id="btnSubmit" onClick={addGift}>{this.state.translation.result_v8}</button>
          <br/><br/><span className="subtitle">{this.state.translation.result_v12}<br/>{this.state.translation.result_v13}</span>
        </div>
          
      </div>
			</React.Fragment>
		);
	}
}

export default Result;